import messages from './messages'
import meta from './meta'

export default {
  messages,
  meta,
}
